import { getIsTrainIncident } from '@rsos/base-utils';
import {
  CORPORATE_CALL_TO_EMERGENCY_NUMBER,
  EXECUTIVE_CALL_TO_EMERGENCY_NUMBER,
} from '@rsos/constants/alertEmergencyTypes';
import CorporatePhoneBanner from './CorporatePhoneBanner';
import ExecutivePhoneBanner from './ExecutivePhoneBanner';
import NoTrainADRBanner from './NoTrainADRBanner';

const Banners = ({
  isCentralStation,
  currentAdrData,
  emergencyType,
  isRestrictedLocation,
}) => {
  const hasNoAdrBanner =
    isCentralStation &&
    !currentAdrData?.data.length &&
    getIsTrainIncident(emergencyType?.name, true);

  const isCorporatePhoneBanner =
    isCentralStation &&
    emergencyType?.name === CORPORATE_CALL_TO_EMERGENCY_NUMBER;

  const isExecutivePhoneBanner =
    isCentralStation &&
    !isRestrictedLocation &&
    emergencyType?.name === EXECUTIVE_CALL_TO_EMERGENCY_NUMBER;

  return (
    <>
      {hasNoAdrBanner && <NoTrainADRBanner />}
      {isCorporatePhoneBanner && <CorporatePhoneBanner />}
      {isExecutivePhoneBanner && <ExecutivePhoneBanner />}
    </>
  );
};

export default Banners;
